import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Expertise from "@/components/Expertise";
import Services from "@/components/Services";
import Languages from "@/components/Languages";
import ZoneIntervention from "@/components/ZoneIntervention";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-paper text-ink font-sans overflow-x-clip">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Expertise />
      <Services />
      <Languages />
      <ZoneIntervention />
      <About />
      <Testimonials />
      <QuoteSection />
      <Footer />
    </div>
  );
}
